import './PopoverToggleButton.css'
import { PopoverButton as HeadlessPopoverButton } from '@headlessui/react'
import cx from 'classnames'

export const PopoverToggleButton = ({ children }: { children: React.ReactNode }) => {
  return (
    <HeadlessPopoverButton
      className={({ open }) => {
        return cx('popover-toggle-button ', {
          'popover-toggle-button-open': open
        })
      }}
    >
      {children}
    </HeadlessPopoverButton>
  )
}
